export default {
  userRole: {
    SuperUser: "superuser",
    Manager: "manager",
    CustomerAdmin: "customer-admin",
    Customer: "customer",
    System: "system"
  }
};

/*
SuperUser: Darf alles
System: Darf alles und darf nur einmal vorhanden sein, darf nicht gelöscht werden können
Manager: Alles bis auf Mandanten bearbeiten
*/
